import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, notification} from 'antd';

import {addBrand} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";

const FormItem = Form.Item;
const TextArea = Input.TextArea;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class AddBrandForm extends Component {
  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {salonId} = this.props;
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.addBrand({...values, salonId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading} = this.props;
    return (
      <Card title="Add Brand">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Description"
          >
            {getFieldDecorator('description', {
              initialValue: ''
            })(
              <TextArea />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Add Brand
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

AddBrandForm.propTypes = {
  history: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  form: PropTypes.object.isRequired,
  salonId: PropTypes.string.isRequired,
  addBrand: PropTypes.func.isRequired
};

const AddBrandPage = Form.create()(AddBrandForm);

const mapStateToProps = state => ({
  loading: state.brand.addingBrand,
  salonId: state.salon.selectedSalonId,
});

const mapDispatchToProps = dispatch => ({
  addBrand: payload => (dispatch(addBrand(payload)))
});

export default connect(mapStateToProps, mapDispatchToProps)(AddBrandPage);



// WEBPACK FOOTER //
// ./src/Brand/AddBrandPage.js